var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-result-page"},[_c('img',{attrs:{"src":_vm.resultImg}}),_c('p',{staticClass:"result"},[_vm._v("\n    "+_vm._s(_vm.approvalStatus === 2
        ? "您的签署申请审核未通过!"
        : "您的签署申请已提交审核， 请耐心等待~")+"\n  ")]),_c('div',{staticClass:"tips"},[_vm._v("\n    "+_vm._s(_vm.approvalStatus === 2
        ? `失败原因：${_vm.refuseReason}`
        : "审核结果将在3个工作日内完成，请关注短信通知")+"\n  ")]),_c('cube-button',{staticClass:"btn",class:{ fail_btn: _vm.approvalStatus === 2 },on:{"click":_vm.clickFn}},[_vm._v(_vm._s(_vm.approvalStatus === 2 ? "重新签署" : "返回首页"))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }